(function () {
    angular.module('app').component('pharmacyPrescriptionsTicketHistoryComponent', {
        templateUrl: require('/App/pharmacy/views/prescriptions/ticketHistory/ticketHistory.component.html'),
        controller: ['$scope', '$stateParams', 'abp.services.app.prescription', controller],
        controllerAs: 'vm',
        bindings: {
            onRefreshEvent: '<',
            onClickFulfillmentNumber: '&'
        }
    });

    function controller($scope, $stateParams, prescriptionSvc) {
        var vm = this;
        vm.ticketHistories = [];
        vm.loading = 0;
        vm.totalCount = 0;
        vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');

        vm.requestParams = {
            maxResultCount: 5,
            skipCount: 0,
            prescriptionNumber: $stateParams.prescriptionNumber
        };

        vm.refresh = function () {
            vm.requestParams.skipCount = 0;
            vm.getTicketHistories();
        };

        vm.$onChanges = function (changes) {
            if (changes.onRefreshEvent && changes.onRefreshEvent.currentValue) {
                vm.onRefreshEvent.handler = vm.getTicketHistories;
            }
        };

        vm.$onInit = function init() {
            vm.getTicketHistories();
        };

        vm.showFulfillment = function (fulfillmentNumber) {
            vm.onClickFulfillmentNumber({ fulfillmentNumber: fulfillmentNumber })
        };

        vm.getTicketHistories = function () {
            vm.loading++;
            var skipCount = vm.requestParams.skipCount;
            if (skipCount === 0) {
                vm.records = [];
            }
            prescriptionSvc.getSpecialistAndInpatientTicketHistories(vm.requestParams).success(function (data) {
                vm.ticketHistories = data.items;
                vm.totalCount = data.totalCount;
                vm.records = _.uniqBy(vm.records.concat(data.items), 'id');
                vm.hasMore = vm.records.length < vm.totalCount;
            }).finally(function () {
                vm.loading--;
            });
        };

        vm.loadMore = function () {
            if (!vm.loading && vm.hasMore) {
                vm.requestParams.maxResultCount += 5;
                vm.getTicketHistories();
            }
        };
    }
})();
